<template>
	<div class="modal-wrapper" @click="close">
		<div class="modal-container modal-container-full" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12">
						SINCRONIZAR CARGAS DO ROTEIRO: {{ current.name.toUpperCase() }}
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body modal-body-full">
				<div class="container-list">
                    <div v-if="loading" class="row">
                        <div class="col-xs-12 col-lg-12">
                            <div class="loading loading-full">
                                <span class="loading-percent"><b>{{ percent }}%</b></span>
                                <span class="loading-text">{{ loading_text }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="view == 'selection'" class="row">
                        <div class="col-xs">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-offset-4 col-lg-4 list-search">
                                        <FormInput v-model="search" label="Busque o veículo" type="text" icon="fa-search" tooltip="Informe a placa ou motorista na listagem abaixo" ref="search" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Veículos</h4></div>
                                    <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Total: {{ list.length }}</h4></div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row list-head">
                                    <div class="col-xs-1 list-head-item">#</div>
                                    <div class="col-xs-1 list-head-item">Placa</div>
                                    <div class="col-xs-2 list-head-item">Percurso</div>
                                    <div class="col-xs-2 list-head-item">Motorista</div>
                                    <div class="col-xs-2 list-head-item">Transportadora</div>
                                    <div class="col-xs-1 list-head-item">Pedidos</div>
                                    <div class="col-xs-1 list-head-item">Peso</div>
                                    <div class="col-xs-2 list-head-item">Situação</div>
                                </div>
                            </div>
                            <div v-if="searchedList().length > 0" class="col-xs-12 list list-body">
                                <div v-for="(vehicle, indexVehicle) in searchedList()" :key="'vehicle-' + indexVehicle">
                                    <div class="row list-body-item">
                                        <div class="col-xs-12 collapsed-list-head">
                                            <div class="row">
                                                <div class="col-xs-1 list-body-item-text collapsed-list-head-button pointer" @click="hideCollapsedBody(indexVehicle)"><i :id="'collapsed-button-' + indexVehicle" class="fas fa-angle-up"></i></div>
                                                <div class="col-xs-1 list-body-item-text">{{ vehicle.vehicle_license_plate }}</div>
                                                <div class="col-xs-2 list-body-item-text">
                                                    <select v-model="vehicle.course" ref="course">
                                                        <option value="">Não definido</option>
                                                        <option value="0 - PADRAO">PADRÃO - 0</option>
                                                        <option v-for="(course, indexCourse) in my_courses" :key="indexCourse" :value="course.code + ' - ' + course.course">{{ course.course }} - {{ course.code }}</option>
                                                    </select>
                                                </div>
                                                <div class="col-xs-2 list-body-item-text">
                                                    <select v-model="vehicle.driver_name_document" ref="driver_document" @change="updateDriver(vehicle)">
                                                        <option value="">Não definido</option>
                                                        <option v-if="default_driver_code" :value="default_driver_code + ' - ' + 'PADRAO'">PADRÃO - {{ getDocumentFormatted(default_driver_code) }}</option>
                                                        <option v-for="(driver, indexDriver) in my_drivers" :key="indexDriver" :value="driver.document + ' - ' + driver.name">
                                                            {{ driver.name.toUpperCase() }} - {{ driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-xs-2 list-body-item-text" :class="!default_shipping_company_code ? 'empty-text' : ''">{{ default_shipping_company_code ? "PADRÃO - " + getDocumentFormatted(default_shipping_company_code) : "Não definida" }}</div>
                                                <div class="col-xs-1 list-body-item-text">{{ vehicle.total_delivery }}</div>
                                                <div class="col-xs-1 list-body-item-text">{{ getWeight(vehicle.total_weight) }}</div>
                                                <div class="col-xs-2 list-body-item-text resume" :class="vehicle.error ? 'error' : 'success'">{{ vehicle.error ? vehicle.message : 'Pronto para sincronizar' }}</div>
                                            </div>
                                        </div>
                                        <div :id="'collapsed-list-body-' + indexVehicle" class="col-xs-12 col-lg-12 collapsed-list-body" hidden="true">
                                            <div v-if="vehicle.deliveries.length > 0">
                                                <div class="row collapsed-list-head">
                                                    <div class="col-xs-2 collapsed-list-head-item">ID Pedido</div>
                                                    <div class="col-xs-2 collapsed-list-head-item">Pedido</div>
                                                    <div class="col-xs-2 collapsed-list-head-item">ID Cliente</div>
                                                    <div class="col-xs-5 collapsed-list-head-item">Cliente</div>
                                                    <div class="col-xs-1 collapsed-list-head-item">Seq.</div>
                                                </div>
                                                <div v-for="(delivery, indexDelivery) in vehicle.deliveries" class="row collapsed-list-body-item" :key="'delivery-' + indexDelivery">
                                                    <div class="col-xs-2 list-body-item-text">{{ delivery.delivery_code }}</div>
                                                    <div class="col-xs-2 list-body-item-text">{{ delivery.delivery_document_number }}</div>
                                                    <div class="col-xs-2 list-body-item-text">{{ delivery.customer_code }}</div>
                                                    <div class="col-xs-5 list-body-item-text capitalized">{{ delivery.customer_name.toLowerCase() }}</div>
                                                    <div class="col-xs-1 list-body-item-text">{{ delivery.sequence }}</div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="row list-body-error">
                                                    <div class="col-xs-12 resume text-center"><i>Não foram encontrados pedidos a tribuídos a carga desse veículo.</i></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="col-xs-12 text-center">
                                <small><i>Não foram encontrados os registros de veículos atribuídos a esse roteiro.</i></small>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="view == 'synchronized'" class="row">
                        <div class="col-xs">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Veículos</h4></div>
                                    <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Processados: {{ list.length }}</h4></div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row list-head">
                                    <div class="col-xs-1 list-head-item">#</div>
                                    <div class="col-xs-1 list-head-item">Placa</div>
                                    <div class="col-xs-2 list-head-item">Percurso</div>
                                    <div class="col-xs-2 list-head-item">Motorista</div>
                                    <div class="col-xs-2 list-head-item">Transportadora</div>
                                    <div class="col-xs-1 list-head-item">Pedidos</div>
                                    <div class="col-xs-1 list-head-item">Peso</div>
                                    <div class="col-xs-2 list-head-item">Situação</div>
                                </div>
                            </div>
                            <div v-if="list.length > 0" class="col-xs-12 list-body">
                                <div v-for="(register, index) in list" :key="'register-' + index" class="row list-body-item">
                                    <div class="col-xs-1 list-body-item-text">
                                        <span v-if="!register.uploaded" class="gray"><i class="fas fa-fw fa-circle-notch fa-spin"></i></span>
                                        <span v-else :class="(register.error && (register.message != 'Sincronizado')) ? 'error' : 'success'"><i class="fas fa-fw" :class="(register.error && (register.message != 'Sincronizado')) ? 'fa-times-circle' : 'fa-check-circle'"></i></span>
                                    </div>
                                    <div class="col-xs-1 list-body-item-text">{{ register.vehicle_license_plate }}</div>
                                    <div class="col-xs-2 list-body-item-text" :class="!register.course_name ? 'empty-text' : ''">{{ register.course_name ? register.course_name + " - " + register.course_code : "Não definido" }}</div>
                                    <div class="col-xs-2 list-body-item-text" :class="!register.driver_name ? 'empty-text' : ''">{{ register.driver_name ? register.driver_name + ' - ' + register.driver_document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "Não definido" }}</div>
                                    <div class="col-xs-2 list-body-item-text" :class="!default_shipping_company_code ? 'empty-text' : ''">{{ (default_shipping_company_code ? "PADRÃO - " + getDocumentFormatted(default_shipping_company_code) : "Não definda") }}</div>
                                    <div class="col-xs-1 list-body-item-text">{{ register.deliveries.length }}</div>
                                    <div class="col-xs-1 list-body-item-text">{{ getWeight(register.total_weight) }}</div>
                                    <div class="col-xs-2 list-body-item-text resume">
                                        <span v-if="register.uploaded" :class="register.error ? 'error' : 'success'">{{ register.message }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="col-xs-12 text-center">
                                <small><i>Não foram encontrados registros de veículos sincronizados.</i></small>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
			<div class="modal-footer">
				<div v-if="view == 'selection'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="sync">
                            ENVIAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-upload'"></i>
                        </button>
                    </div>
                </div>
                <div v-else-if="view == 'synchronized'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> FECHAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";

export default {
	name: "RoutingModalSynchronizationAtak",

	props: {
        current: {
            type: Object,
            require: true,
        },
        my_drivers: {
            type: Array,
            require: true,
        },
        my_courses: {
            type: Array,
            require: true,
        },
        integration: {
            type: String,
            require: false,
            default: "",
        },
        url_api_atak: {
            type: String,
            require: false,
            default: "",
        },
        default_driver_code: {
            type: String,
            require: false,
            default: "",
        },
        default_shipping_company_code: {
            type: String,
            require: false,
            default: "",
        },
    },

    components: {
        FormInput,
    },

	data: function() {
		return {
            loading: false,
            view: "selection",
            
            search: "",
            
            list: [],
            total: 0,

            synchronized_count: 0,
            percent: 0,
            loading_text: "",
		}
	},
    
    beforeMount: async function() {
        if(this.integration == "") {
            if (!this.$api.user.company_client_atak) {
                this.$notification.error("Configuração de integração não selecionada em: Configurações -> Roteirização.");
                this.close();
                return;
            }
        } 
        
        if (this.url_api_atak == "") {
            this.$notification.error("Endereço da API de integração não informado em: Configurações -> Roteirização.");
            this.close();
            return;
        }
        
        await this.load();
    },

	methods: {
        // Busca lista de veículos
		load: async function() {
            // Reinicia as informações gerais
			this.list = [];
			this.total = 0;
            
            // Requisita as informações
            this.loading = true;
            let result = null;
            try {
                result = await Api.post("delivery-routing/get-delivery-routing-vehicle", {
                    id: this.current.id,
                });
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível recuperar os veículos do roteiro.");
                this.loading = false;
                return;
            }
            // Finaliza as informações

			if (result) {
				if (result.error) {
					this.$notification.error(result.data);
                    this.loading = false;
					return;
				}
                
				this.list = result.data;
				this.total = result.total;

                this.list.map(element => {
                    element.course_code = "0";
                    element.course_name = "PADRAO";
                    element.course = element.course_code + " - " + element.course_name;
                    if (element.driver_document == null) {
                        if (this.default_driver_code != "") {
                            element.driver_name_document = this.default_driver_code + " - " + "PADRAO";
                        } else {
                            element.driver_name_document = "";
                        }
                    } else {
                        element.driver_name_document = element.driver_document + " - " + element.driver_name;
                    }
                });
                this.loading = false;
				return;
			} else {
				this.$notification.error("Não foi possível obter a lista de veículos do roteiro.");
                this.loading = false;
				return;
			}
		},

        // Autentica com a Web API Atak
        auth: async function() {
            // Inicia a requisição
            this.loading = true;
            this.loading_text = "Solicitando autorização...";
            let result = false;
            try {
                result = await Api.post("synchronizer/auth", {
                    integration: this.integration,
                    url: this.url_api_atak,
                });
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível conectar com a API do sistema integrado.");
                return false;
            }

            // Finaliza a requisição
            this.loading = false;
            this.loading_text = "";

            // Verifica se houve error
            if (result.error) {
				this.$notification.error(result.data);
				return false;
			} else {
                return result.data;
            }
		},

        // Envia os dados da carga para o sistema integrado
        sync: async function() {
            // Define a variável necessária
            let check = true;

            // Verifica se um motorista está em mais de uma rota
            for (let driver of this.my_drivers) {
                let count = 0;
                for (let register of this.list) {
                    if (driver.document == register.driver_document) count++;
                }
                if (count > 1) {
                    check = false;
                    this.$notification.error("Motorista, " + driver.name + ", está selecionado para mais de uma rota no mesmo período.");
                }
            }
            
            // Verifica se é para sincronizar
            if (check) {
                // Obtém o token de autorização
                let token = await this.auth();
                
                // Verifica se foi obtido o token
                if(token) {
                    // Exibe a lista de sincronização
                    this.view = "synchronized";

                    // Inicia a sincronização
                    this.loading = true;

                    // Inicia a contagem de sincronização
                    this.synchronized_count = 0;
                    this.percent = 0;
                    this.loading_text = "Enviando cargas..."

                    // Solicita para cada registro
                    for (let register of this.list) {
                        // Verifica se há erro
                        if (!register.error) {
                            // Define o resultado
                            let result = null;
                            
                            // Verifica o percurso selecionado
                            if (register.course != "") {
                                register.course_code = register.course.split(" - ")[0];
                                register.course_name =  register.course.split(" - ")[1];
                            } else {
                                register.course_code = "";
                                register.course_name = "";
                            }

                            // Verifica se não há motorista definido mas há um selecionado
                            if (!register.driver_document && !register.driver_name && register.driver_name_document) {
                                this.updateDriver(register);
                            // Verifica se não há motorista definido, não há selecionado mas há um padrão
                            } else if (!register.driver_document && !register.driver_name && !register.driver_name_document && this.default_driver_code) {
                                register.driver_document = this.default_driver_code;
                                register.driver_name = "PADRAO";
                            // Verifica se não há motorista definido, não há selecionado nem há um padrão
                            } else if (!register.driver_document && !register.driver_name && !this.default_driver_code) {
                                register.uploaded = true;
                                register.error = true;
                                register.message = "Motorista não informado. O Código do Motorista Padrão do sistema integrado deve ser informado em: Configurações -> Roteirização.";

                                this.synchronized_count++;
                                this.calcPercent(this.synchronized_count);
                                continue;
                            }
                            
                            // Verifica a definição da transportadora padrão
                            if (this.default_shipping_company_code) {
                                register.default_shipping_company_code = this.default_shipping_company_code;
                            } else {
                                register.uploaded = true;
                                register.error = true;
                                register.message = "Transportadora não informada. O Código da Transportadora Padrão do sistema integrado deve ser informado em: Configurações -> Roteirização.";

                                this.synchronized_count++;
                                this.calcPercent(this.synchronized_count);
                                continue;
                            }
                            
                            // Faz o request
                            try {
                                result = await Api.post("synchronizer/send-cargo", {
                                    integration: this.integration,
                                    url: this.url_api_atak,
                                    token: token,
                                    routing: this.current,
                                    vehicle: register,
                                });
                            } catch (ex) {
                                console.log(ex);
                                
                                register.uploaded = true;
                                register.error = true;
                                register.message = "Não foi possível sincronizar";

                                this.synchronized_count++;
                                this.calcPercent(this.synchronized_count);
                                continue;
                            }
                            register.uploaded = true;
                            // Termina o request

                            // Verifica se houve erro
                            if (!result.error) {
                                register.error = false;
                                register.message = result.data;
                            } else {
                                register.error = true;
                                if (result.data != "unauthorized") {
                                    register.message = result.data;
                                } else {
                                    register.message = "Sessão expirada";
                                }
                            }
                            
                            // Atualiza as informações
                            this.synchronized_count++;
                            this.calcPercent(this.synchronized_count);
                            this.$forceUpdate();
                        } else {
                            register.uploaded = true;
                        }
                    }

                    // Inicia a sincronização
                    this.loading = false;
                    this.loading_text = "";
                    return;
                }
                
                // Finaliza a sincronização
                return;
            } else {
                // Cancela a operação
                return;
            }
		},

        // Filtra com a lista
        searchedList: function() {
            if(this.search) {
                let exp = new RegExp(this.search.trim(), 'i');
                let searched_list = this.list.filter(register => 
                    !register.error ?
                        exp.test(register.vehicle_license_plate) || 
                        exp.test(register.driver_name) || 
                        exp.test(register.driver_document)
                    : false
                );
                
                return searched_list;
            } else {
                return this.list;
            }
        },
        
        // Aatualiza o motorista atual do veículo
        updateDriver: function(vehicle) {
            // Verifica a definição do mototista e documento
            if (vehicle.driver_name_document) {
                let driver_name_document = vehicle.driver_name_document.split(" - ");
                if (driver_name_document.length == 2) {
                    vehicle.driver_document = driver_name_document[0];
                    vehicle.driver_name = driver_name_document[1];
                } else {
                    vehicle.driver_document = "";
                    vehicle.driver_name = "";
                }
            } else {
                vehicle.driver_document = "";
                vehicle.driver_name = "";
            }
        },

        getDocumentFormatted: function(document) {
            if (document.length == 11) {
                return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            } else if (document.length == 14) {
                return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            } else {
                return document;
            }
        },

        getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

        hideCollapsedBody: function(index) {
            let elementButton = document.getElementById("collapsed-button-" + index);
            let elementBody = document.getElementById("collapsed-list-body-" + index);
            if (elementBody.hidden) {
                elementButton.classList.remove("fa-angle-up");
                elementButton.classList.add('fa-angle-down');
                elementBody.hidden = false;
            } else {
                elementButton.classList.remove("fa-angle-down");
                elementButton.classList.add('fa-angle-up');
                elementBody.hidden = true;
            }
        },

        calcPercent: function(current) {
            this.percent = parseInt((current * 100) / this.list.length);
        },

		// Fecha o modal
		close: function() {
			this.$emit("close");
        },
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 800px;
	height: 240px;
}

.modal-container-full {
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 130px;
}

.modal-body-full {
    height: calc(100vh - 140px);
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.btn-sync {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}
.btn-sync:disabled {
    background: #a0a0a0;
}

/*.btn-margin-top {
    margin-top: 30px;
}*/

.sync-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.sync-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.sync-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 15px;
	padding: 10px;
}

.sync-list-synchronized-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}

.sync-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.sync-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}

.sync-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}

.sync-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.capitalized {
	text-transform: capitalize;
}

.pointer {
    cursor: pointer;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.list {
    margin-bottom: 30px;
}

.list-name, 
.list-search, 
.list-total {
    display: grid;
    align-content: center;
}

.list-name, 
.list-total {
    border-bottom: 1px solid #ccc;
}

.list-name > h4, 
.list-total > h4 {
    margin-top: 0px;
    margin-bottom: 5px;
}

.list-total > h4 {
    font-size: 1;
    font-weight: 400;
}

.list-head-item {
    /*font-size: 14px;*/
    font-weight: 600;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    background-color: #eee;
}

.list-body-item {
    /*font-size: 14px;*/
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ccc;
	border-radius: 3px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
    margin-top: 5px;
}

.list-body-item-cell {
    display: grid;
    align-content: center;
}

.list-body-item-text {
    display: grid;
	align-content: center;
}

.list-body-item-text.resume {
    font-size: 13px;
}

.collapsed-list-head-item {
    /*font-size: 14px;*/
    font-weight: 600;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
}

.collapsed-list-body {
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 2px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #f0f0f0;
    font-size: 12px;
}

.collapsed-list-body-item {
    padding-top: 5px;
    padding-bottom: 5px;
}

.collapsed-list-body > div > .collapsed-list-body-item:not(:last-child) {
    border-bottom: 1px dashed #ccc;
}

.collapsed-list-body-item:hover {
    background-color: #e0e0e0;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 129px;
    line-height: 129px;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 141px);
    line-height: calc(100vh - 141px);
}

.loading-icon, 
.loading-percent {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}

.empty-text {
    color: #aaa;
}
</style>